function HealthCheck() {
  return <div>OK</div>;
}

export default HealthCheck;